/** Firebase Client Configuration
 *
 * This module integrates Firebase Authentication with Azure App Registry:
 *
 * 1. Firebase Configuration:
 *    - Project: palo-points
 *    - Authentication is handled through Firebase Auth
 *    - Configuration values are obtained from Firebase Console
 *      (https://console.firebase.google.com/project/palo-points)
 *
 * 2. Azure App Registry Integration:
 *    - The API key is segmented for security following Azure best practices
 *    - The key segments are stored in Azure App Registry
 *    - Format: AIzaSy... (Standard Firebase API key format)
 *    - App Name: Palo IT Mexico - Palo Points
 *    - App ID: 9c241c5a-5ea0-414f-8df4-8c47c6007589
 *    - Azure Certificate Creation: April 28, 2025
 *    - Azure Certificate Expiration: April 28, 2027
 *
 * Important: The Azure Certificate key must be configured in Firebase Console under:
 * Authentication -> Sign-in method -> Microsoft -> Configure
 */

import {initializeApp} from 'firebase/app';
import {getAuth} from 'firebase/auth';

// Azure App Registry segments for the Firebase API key
const api = ['AIzaSyDEECtlJ_', 'pmYVKhkkUZAKye4rfjx_', 'F1VGU'];

// Firebase configuration object with integrated Azure App Registry values
const firebaseConfig = {
  apiKey: api.join(''),
  authDomain: 'palo-points.firebaseapp.com',
  projectId: 'palo-points',
  storageBucket: 'palo-points.appspot.com',
  messagingSenderId: '819347905994',
  appId: '1:819347905994:web:d197204f094ad6bdd18333',
};

// Initialize Firebase application instance
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);
